import { type FunctionComponent, } from "react";
import { createPortal, } from "react-dom";
import { formatAddress,  } from "./helpers";
import { Compass, Copy, Power, } from "@icons";
import { getBlockExplorerLink, } from "@helpers";
import { wagmiConfig } from "@config";
import { useAccount, useDisconnect } from "wagmi";


export declare type AccountDDProps = {
	rect: DOMRect;
};


export const AccountDD: FunctionComponent<AccountDDProps> = ({
	rect,
}) => {
	const { disconnect } = useDisconnect()

	const { address} = useAccount()
	const classes = () => [`dropdown-panel`, `account`].join(" ");
	const el = document.getElementById("connManUIRoot");
	const { clientWidth } = document.body;

	const style = () => ({
		right: clientWidth - rect.right,
		top: rect.top + rect.height,
	});



	const onAddressCopy = () => {
		if( address ) {
			navigator.clipboard.writeText(address);
		}
	}

	const onAddressClick = () => {
		const link = `${getBlockExplorerLink()}${ address ? `address/${address}` : `` }`;
		window.open(link, "_blank");
	}



	const onBlockExplorer = () => {
		const link = getBlockExplorerLink() + `address/${address}`;
		window.open(link, "_blank");
	};

	if (el) {
		if (address) {

			return createPortal(
				<div className={classes()} style={style()}>
					<div className="upper">
						<div className="address" onMouseDown={onAddressCopy}>
							<div className="label">{formatAddress(address)}</div>
							<div className="icon"><Copy /></div>
						</div>
					</div>
					<div className="lower">
						<div className="explorer" onMouseDown={onBlockExplorer}>
							<div className="icon"><Compass /></div>
							<div className="label">block explorer</div>
						</div>
						<div className="disconnect" onMouseDown={evt => {
							// Call disconnect multiple times because if many wallets are used sometimes it requires to click multiple times
							disconnect()
							setTimeout(() => {
								disconnect();
							}, 10)
							setTimeout(() => {
								disconnect();
							}, 20)

							setTimeout(() => {
								disconnect();
							}, 100)

							setTimeout(() => {
								disconnect();
								disconnect();
							}, 300)

							setTimeout(() => {
								disconnect();
								disconnect();
							}, 500)
						}}>
							<div className="icon"><Power /></div>
							<div className="label">disconnect</div>
						</div>
					</div>
				</div>,
				el
			);
		}
		throw new Error("ConnectionManager::AccountDD was invoked for rendition but no address has been set");
	}
	throw new Error("ConnectionManager::ChooseChainDD could not locate the UI root");
}
